import {http} from './config/config-relation-register'

export default{
    listar:async(token)=>{
        return  http.get('unidades',{
            headers:{
                'Authorization':token
            }
        })
    },
    salvar:(token, produto)=>{
        return http.post('unidades',produto,{
            headers:{
                'Authorization':token
            }
        })
    },
    deletar:(token, idItem)=>{
        return http.delete('unidades/'+idItem,{
            headers:{
                'Authorization':token
            }
        })
    },
    update:(token, produto)=>{
        return http.put('unidades/'+produto.id_unidade,produto,{
            headers:{
                'Authorization':token
            }
        })
    }

}